import { iBasicState } from "../../interfaces/interfaces";
import { tBasicAction, eBasicActionTypes } from "./basicTypes";

const initialState: iBasicState = {
	currentStep: 0,
	// currentStep: 2,	// temp
	currentFToken: null,	// temp
	// currentFToken: 'USDT',	// temp
	// currentFToken: 'USD',	// temp
	// current_u_token: null,
	currentUToken: null,	// temp
	// currentUToken: 'BTC',	// temp
	currentDirection: null,
	currentMaturityDate: null,
	currentStrike: null,
}

export const basicReducer = ( state = initialState, action: tBasicAction) : iBasicState => {
	switch (action.type) {
		case eBasicActionTypes.SET_CURRENT_STEP:
			switch (action.payload) {
				case 0:
					return initialState;

				case 1:
					return {...state, currentStep: 1, currentDirection: null};

				case 2:
					return {...state, currentStep: 2, currentMaturityDate: null};

				case 3:
					return {...state, currentStep: 3, currentStrike: null};

				default:
					return state;
			}

		case eBasicActionTypes.SET_CURRENT_F_TOKEN:
			return {...state, currentFToken: action.payload};

		case eBasicActionTypes.SET_CURRENT_U_TOKEN:
			return {...state, currentUToken: action.payload, currentStep: 1};

		case eBasicActionTypes.SET_CURRENT_DIRECTION:
			return {...state, currentDirection: action.payload, currentStep: 2};

		case eBasicActionTypes.SET_CURRENT_MATURITY_DATE:
			return {...state, currentMaturityDate: action.payload, currentStep: 3};

		case eBasicActionTypes.SET_CURRENT_STRIKE:
			return {...state, currentStrike: action.payload, currentStep: 4};

		case eBasicActionTypes.STEP_BACK:
			switch (state.currentStep) {
				case 1: // choosed u_token
					return initialState;

				case 2: // choosed direction
					return {...state, currentStep: 1, currentDirection: null};

				case 3: // choosed maturity
					return {...state, currentStep: 2, currentMaturityDate: null};

				case 4: // choosed strike
					return {...state, currentStep: 3, currentStrike: null};

				default:
					return state;
			}

		default:
			return state;
	}
}